import PluginAddendumPage from '../components/LegalPages/components/PluginAddendumPage';
import { publicMeta } from './public-meta';

export const meta = publicMeta('Plugin Addendum | Cartwheel');

export default PluginAddendumPage;
